import { FormattedMessage } from 'react-intl'

import { Button } from '@gto/ui/button'
import { useMediaQuery } from '@gto/ui/hooks/use-media-query'
import { ChatBubbleLeftRightIcon } from '@gto/ui/icons/outline'
import { Typography } from '@gto/ui/typography'

import { AbsoluteSuitsOnCorners } from '@/components/absolute-suits-on-corners'
import { useSupportLinks } from '@/components/support-links'

export const SupportBanner = () => {
  const isSmAndLower = useMediaQuery('down', 'sm')

  return (
    <section className="relative mt-12 flex flex-col items-center px-0 py-12 sm:px-4">
      <AbsoluteSuitsOnCorners top={0} />
      <div className="flex max-w-[65%] flex-row items-center justify-center gap-8 lg:max-w-[70%] md:max-w-[80%] sm:max-w-full sm:flex-col">
        <div className="text-primary-main">
          <ChatBubbleLeftRightIcon
            color="inherit"
            height={isSmAndLower ? 120 : 180}
          />
        </div>
        <div className="flex flex-col gap-8">
          <Typography
            className="text-left"
            component="h2"
            variant="h3"
          >
            <FormattedMessage id="home.support.title" />
          </Typography>

          <div className="flex flex-col sm:gap-8">
            <Typography
              gutterBottom
              className="text-left font-semibold sm:text-center"
              color="primary"
              component="h3"
              variant="h6"
            >
              <FormattedMessage id="home.support.description" />
            </Typography>
            <div className="m-0 flex w-auto flex-row flex-wrap items-center justify-start gap-2 sm:mx-auto sm:my-0 sm:w-full sm:flex-col sm:items-stretch sm:gap-4">
              {useSupportLinks().map((link) => (
                <Button
                  key={link.gaTag}
                  aria-label={link['aria-label']}
                  color="secondary"
                  href={link.href}
                  rel={link.rel}
                  size="large"
                  startIcon={link.icon}
                  target={link.target}
                  variant="contained"
                >
                  {link.label}
                </Button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
